/* eslint-disable */
import React from "react";
import PropTypes from "prop-types";
import {  Router, Switch, Route, BrowserRouter } from 'react-router-dom';

// creates a beautiful scrollbar
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// core components
import Navbar from "components/Navbars/Navbar.jsx";
import Footer from "components/Footer/Footer.jsx";
import Sidebar from "components/Sidebar/Sidebar.jsx";
import FixedPlugin from "components/FixedPlugin/FixedPlugin.jsx";
import routes from "routes.js";
import dashboardStyle from "assets/jss/material-dashboard-react/layouts/dashboardStyle.jsx";
import image from "assets/img/hk.jpg";
import logo from "assets/img/tk.png"
import endpoint from '../variables/endPoint.js'
import { withCookies, Cookies } from 'react-cookie';
import { instanceOf } from 'prop-types';
import { CookiesProvider } from 'react-cookie';
import {cookies} from '../variables/cookies.js'
import { SnackbarProvider, withSnackbar } from 'notistack';



class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    //const { cookies } = props;
  /*  var user = ""
    var project = ""
    if(this.props.location.state == undefined){
      user = cookies.get('userInfo')
      project = {
        "couse_id": null,
        "group_name": null,
        "members": [],
        "peer_eva": null,
        "presen_date": "0000000000",
        "project_description": null,
        "project_name": null,
        "ratingFinished": null,
        "section": null
      }
    }
    else{
      user = this.props.location.state.userInfo
      project = this.props.location.state.myProjectInfo
    }*/
    var user = this.props.location.state.userInfo
    this.state = {
      userInfo: user,
      courseInfo: [],
      image: image,
      color: "blue",
      hasImage: true,
      fixedClasses: "dropdown",
      mobileOpen: false,
      name: cookies.get('name') || 'Ben',
      curSemester: "",
      allSems:[]
    };
    this.loadCourseInfo = this.loadCourseInfo.bind(this)
    this.loadCourseInfo();
    /*if(this.props.location.state == undefined){
      this.loadMyProjectInfo(this.state.userInfo)
    }*/
  }

  updateCourseInfo = (sem) =>{
    fetch( endpoint +"/admin/getCourseInfo", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        semester: sem
      })
    })
      .then(res => res.json())
      .then(res => {
        if (res.err) {
        } else {
            this.setState({
              courseInfo: res.data
            })
        }
      });
  }

  loadCourseInfo = (userInfo) =>{
    var allSems = this.state.userInfo.screen_name.split(";")
    var curSemester = allSems[allSems.length - 1]//for admin account, cur sem is stored in screen_name
    console.log("parent loadCourseInfo: ", curSemester)
    fetch( endpoint +"/admin/getCourseInfo", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        semester: curSemester
      })
    })
      .then(res => res.json())
      .then(res => {
        if (res.err) {
        } else {
            this.setState({
              courseInfo: res.data,
              curSemester: curSemester,
              allSems: allSems
            })
        }
      });
  }

  updateCurSem = sem =>{
    console.log("parent update sem: ", sem)
    this.setState({ curSemester: sem });
    this.updateCourseInfo(sem)
  }

  handleImageClick = image => {
    this.setState({ image: image });
  };
  handleColorClick = color => {
    this.setState({ color: color });
  };
  handleFixedClick = () => {
    if (this.state.fixedClasses === "dropdown") {
      this.setState({ fixedClasses: "dropdown show" });
    } else {
      this.setState({ fixedClasses: "dropdown" });
    }
  };
  handleDrawerToggle = () => {
    this.setState({ mobileOpen: !this.state.mobileOpen });
  };
  getRoute() {
    return this.props.location.pathname !== "/admin/maps";
  }
  resizeFunction = () => {
    if (window.innerWidth >= 960) {
      this.setState({ mobileOpen: false });
    }
  };

  componentDidMount() {
    if (navigator.platform.indexOf("Win") > -1) {
      const ps = new PerfectScrollbar(this.refs.mainPanel);
    }
    window.addEventListener("resize", this.resizeFunction);
  }
  componentDidUpdate(e) {
    if (e.history.location.pathname !== e.location.pathname) {
      this.refs.mainPanel.scrollTop = 0;
      if (this.state.mobileOpen) {
        this.setState({ mobileOpen: false });
      }
    }
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.resizeFunction);
  }

  render() {
    const switchRoutes = (
      <Switch>
        {routes.map((prop, key) => {
          if (prop.layout === "/admin") {
            return (
              <Route
                path={prop.layout + prop.path}
                render={() =>
                <SnackbarProvider maxSnack={3}>
                    <prop.component
                      history = {this.props.history}
                      userInfo = {this.state.userInfo}
                      courseInfo = {this.state.courseInfo}
                      curSemester = {this.state.curSemester}
                      updateGlobalCurSem = {this.updateCurSem}
                      allSems = {this.state.allSems}
                    />
                  </SnackbarProvider>
                }
                key={key}
              />
            );
          }
        })}
      </Switch>
    );

    const { classes, ...rest } = this.props;
    return (
      <CookiesProvider>
      <div className={classes.wrapper}>
        <Sidebar
          routes={routes}
          logoText={"Admin"}
          layout={"/admin"}
          logo={logo}
          image={this.state.image}
          handleDrawerToggle={this.handleDrawerToggle}
          open={this.state.mobileOpen}
          color={this.state.color}
          {...rest}
        />
        <div className={classes.mainPanel} ref="mainPanel">
          <Navbar
            routes={routes}
            handleDrawerToggle={this.handleDrawerToggle}
            {...rest}
          />
          {/* On the /maps route we want the map to be on full screen - this is not possible if the content and conatiner classes are present because they have some paddings which would make the map smaller */}
          {this.getRoute() ? (
            <div className={classes.content}>
              <div className={classes.container}>{switchRoutes}</div>
            </div>
          ) : (
            <div className={classes.map}>{switchRoutes}</div>
          )}
          {this.getRoute() ? <Footer /> : null}
          <FixedPlugin
            handleImageClick={this.handleImageClick}
            handleColorClick={this.handleColorClick}
            bgColor={this.state["color"]}
            bgImage={this.state["image"]}
            handleFixedClick={this.handleFixedClick}
            fixedClasses={this.state.fixedClasses}
          />
        </div>
      </div>
    </CookiesProvider>
    );
  }
}

Dashboard.propTypes = {
  classes: PropTypes.object.isRequired,
  cookies: instanceOf(Cookies).isRequired
};

export default withCookies(withStyles(dashboardStyle)(Dashboard));
